import React from 'react';

import LinearVitaminLabel from '../../nutrition-label/components/LinearVitaminLabel';
import { getUomTypesAbbreviations } from '../../nutrition-label/DailyValueConstants';

import { useGetBasicUomEnum } from 'hooks';
import { WrapperLinearLabel } from './overlay/WrapperNutrient';

const highlightLabelName = [
  'FAT',
  'CHOLESTEROL',
  'NA',
  'CHOLESTEROL',
  'CARBOHYDRATES',
  'PROTEIN',
  'FD',
];

function LinearLabel({ label, nutrients, compareValue }) {
  const { basicUomProperties } = useGetBasicUomEnum();

  const checkHighlightName = (typeCode) =>
    highlightLabelName.includes(typeCode);

  return (
    <div className='nutrition-facts__label--linear'>
      <span className='nutrition-facts__label--linear-label'>
        Nutrition Facts
      </span>
      {label?.servingsPerContainer ? (
        <WrapperLinearLabel
          label={['servingsPerContainer']}
          currentValue={label}
          originValue={compareValue}
        >
          <span>Servings: {label?.servingsPerContainer},</span>
        </WrapperLinearLabel>
      ) : (
        <span>,</span>
      )}
      <WrapperLinearLabel
        label={[
          'servingSizeDescription',
          'servingSize',
          'servingSizeMeasurement',
        ]}
        currentValue={label}
        originValue={compareValue}
      >
        <span className='nutrition-facts__label--linear__servingsize-bold'>
          Serv. Size:{' '}
        </span>
        <span className='nutrition-facts__label--linear__servingsize-bold'>
          {label?.servingSizeDescription}{' '}
          {label?.servingSize &&
            `(${label?.servingSize} ${getUomTypesAbbreviations(
              basicUomProperties,
              label?.servingSizeMeasurement
            )}),`}
        </span>
      </WrapperLinearLabel>
      <WrapperLinearLabel
        label={['calories']}
        currentValue={label}
        originValue={compareValue}
      >
        <span>Amount Per Serving:</span>
        <span className='nutrition-facts__label--linear__servingsize-bold'>
          {`Calories ${label?.calories ? label?.calories : 0},`}
        </span>
      </WrapperLinearLabel>
      <>
        {nutrients?.map((ingredient, idx) => (
          <LinearVitaminLabel
            key={idx}
            labelBold={checkHighlightName(ingredient?.nutritionTypeCode)}
            ingredient={ingredient}
          />
        ))}
      </>
    </div>
  );
}

export default LinearLabel;
